import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CreditCard,
  Users,
  Building,
  ArrowRight
} from 'lucide-react';

/**
 * PAGE: GESTION DES PAIEMENTS (ADMIN) - NIVEAU 1
 * 
 * Hub principal avec 2 choix : Mutualistes ou Entreprises
 */

const AdminPayments = () => {
  const navigate = useNavigate();

  const mainCategories = [
    {
      title: 'Mutualistes',
      description: 'Gestion des paiements individuels',
      icon: Users,
      color: 'blue',
      path: '/admin/payments/mutualistes'
    },
    {
      title: 'Entreprises',
      description: 'Gestion des paiements groupés',
      icon: Building,
      color: 'purple',
      path: '/admin/payments/entreprises'
    }
  ];

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="bg-white rounded-xl shadow-card p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-primary-900 mb-2">
              Gestion des Paiements
            </h1>
            <p className="text-gray-600">
              Choisissez le type de paiement à gérer
            </p>
          </div>
          <CreditCard className="h-12 w-12 text-primary-600" />
        </div>
      </div>

      {/* 2 cartes principales */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {mainCategories.map((category, index) => (
          <button
            key={index}
            onClick={() => navigate(category.path)}
            className={`bg-white rounded-xl shadow-card p-8 text-left hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1 group ${
              category.color === 'blue' ? 'hover:border-blue-300' : 'hover:border-purple-300'
            } border-2 border-transparent`}
          >
            <div className="flex flex-col items-center text-center">
              <div className={`p-6 rounded-2xl mb-6 ${
                category.color === 'blue' 
                  ? 'bg-blue-100 text-blue-600 group-hover:bg-blue-200' 
                  : 'bg-purple-100 text-purple-600 group-hover:bg-purple-200'
              } transition-colors duration-200`}>
                <category.icon className="h-16 w-16" />
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                {category.title}
              </h2>
              
              <p className="text-gray-600 mb-6">
                {category.description}
              </p>

              <div className={`flex items-center text-sm font-semibold ${
                category.color === 'blue' ? 'text-blue-600' : 'text-purple-600'
              }`}>
                <span>Accéder</span>
                <ArrowRight className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminPayments;
